const Config = {
  Guest: {
    SignIn: "/api/?app=user/authorization2",
    Ping: "/api/?app=keepAlive&mobile=new&lang={lang}",
    Alive: "/api/?app=live",
    Recovery: "/api/?app=user/recovery",
    Register: "/api/?app=user/registration/{mode}",
  },
  User: {
    DisableAccount: "/api/?app=user/api&service=user_disable&period={period}",
    OTP: "/api/?app=user/api&service=otp",
    Verification: "/api/?app=user/api&service={service}",
    ReVerify: '/api/?app=user/api&service=reverify_sms',
    Accounts: "/api/?app=user/accounts",
    Info: "/api/?app=user/api&service=getInfo",
    Balance: "/api/?app=market/api&resource=getBalance",
    MainBalance: "/api/?app=user/deposits&type=onlymain",
    BalanceToSms: "/api/?app=user/safe&act=sendBalanceToPhone",
    Level: "/api/?app=user/level",
    ResetPassword: "/api/?app=user/api&service=updatePassword",
    Promo: "/api/?app=promo/codes",
    Promotions:
      "/api/?app=aqcia/lottery/api&resource=getUserTickets&id=1667829280",
    AuthHistory: "/api/?app=user/api&service=authHistory",
    TransactionHistory: "/api/?app=user/tr_history",
    TicketHistory: "/api/?app=sport/tickets/historyUof",
    PokerStats: "/api/?app=user/poker&service=getTopExtUsers",
    Cashback: "api/?app=user/accounts&from=12&to=1&money=1",
    Safe: "/api/?app=user/safe&act={act}",
    SetSms: "/api/?app=user/api&service=set_sms",
    SetSmsNotify: "/api/?app=user/api&service=set_sms_notify",
    GetMobile: "/api/?app=user/api&service=getUserMobile",
    UpdateMobile: "/api/?app=user/api&service=updateMobile&{mode}",
    GoMobile: "/api/?app=goMobile&act={action}",
    Referrals: "/api/?app=aqcia/referrals/invite&service=referrals",
    Logout: "/api/?app=logout",
    CheckLeaderCardStatus: "/api/?app=aqcia/api&act=getLiderCardStatus",
    CheckLeaderCardKey: "/api/?app=NBS/keyHash",
    Kvalifika: "/api/?app=user/verification&service=token",
    Notifications: {
      Ping: "/api/?app=user/notification/data&act=generateData&_={timestamp}",
      Read: "/api/?app=user/notification/new&id={id}",
      ReadFeeChange: "/api/?app=user/api&service=read_notification&id={id}",
      smsAdds: "/api/?app=user/api&service=set_sms_adds_status&value={value}"
    },
  },
  Notifications: {
    List: "/user-messages/messages/{lang}/get",
    Get: "/user-messages/messages/get/{id}?platform={platform}",
    Read: "/user-messages/messages/read/{id}",
    ReadAll: "/user-messages/messages/readAll?messages={messages}",
    deleteAll: "/user-messages/messages/deleteAll?messages={messages}",
    Unread: "/user-messages/messages/unread",
  },
  /*Banners: {
    MainPage:
      "/api/?app=banners/banners&resource=get&page=main&platform={platform}",
    PokerPage:
      "/api/?app=banners/banners&resource=get&page=poker&platform={platform}",
  },*/
  Banners:
    "/api/?app=banners/banners&resource=get&page={page}&platform={platform}",
  Slots: {
    Main: "/api/?app=slots/newslot&resource=list",
    Labels: "/api/?app=slots/newslot&resource=list_providers",
    LastPlayed: "/api/?app=slots/slot&resource=lastPlayed",
    Listener: "https://alive.lider-bet.com/Ponger/{hash}",
    Popular: "/api/?app=slots/newslot&resource=list_popular&limit={limit}",
    ReturnMoney:
      "/api/?app=user/games/PlaySlot&act=exitGame&operator={operator}",
    BetMarketGames:
      "/api/?app=market/api&resource=productsByTagName&name={name}",
    BuyBetMarketGame:
      "/api/?app=market/api&resource=buy&item_id={itemId}&operator={operator}",
    Play: "/api/?app=user/games/PlaySlot&act=play",
    PlayEvolution: "/api/?app=evolution_games_staging/play",
  },
  News: {
    Footer: "https://sportcache.lider-bet.com/news/news.json?_={seconds}",
    getNewsFromBanners:'/api/?app=banners/banners&resource=get&page=news&platform=new_desk',
    getGameLobbyPromos:'/api/?app=promo_configs/promo&resource=getConfig&name=sport_under_ticket'
  },
  /*locales: {
    en: "/locales/en.json",
    ka: "/locales/ka.json",
  },*/
  TableGames: {
    ///   /api/?app=user/games/PlaySlot&act=play&catid=74&afterLoad=false&mod=&lang=en&operator=602&game=jetx&provider=null
    Spin: "/api/?app=spin/table&game={gameId}&_token",
    GetJokerToken: "/api/?app=joker/joker&act=token",
    GetPokerToken: "/api/?app=spinpoker/spinpoker&act=token",
    GetJapaneseToken: "/api/?app=japanesejoker/japanesejoker&act=token",
    LeaderPoker: "/api/?app=poker/poker&platform={platform}",
  },
  jetX:"/api/?app=user/games/PlaySlot&act=play&catid=74&afterLoad=false&mod=&lang={lang}&operator=602&game=jetx&provider=null",
  LiveCasino: {
    PlayTech: "/api/?app=user/games/playTechCasino",
    Evolution: "/api/?app=user/games/playEvolution",
  },
  Balance: {
    Volt: "/volt/api/balance/in?money={money}",
    Slot: "/api/?app=user/games/PlaySlot&act=transfer&operator={operator}&from={from}&money={money}",
    PlayTech:
      "/api/?app=user/games/playTechCasino&transfer&from={from}&money={money}",
    Evolution:
      "/api/?app=user/games/playEvolution&transfer&from={from}&money={money}",
    ExitEvolution: "/api/?app=user/games/playEvolution&exitGame",
    ExitJetX:"/api/?app=user/games/PlaySlot&act=exitGame&operator=602",
    ExitPlayTech: "/api/?app=user/games/playTechCasino&exitGame",
    ExitLeaderRoulette: "/play/roulette/api/wallet/finishGame",
    LeaderRoulette:
      "/play/roulette/api/wallet/addMoney?money={money}&_=" +
      new Date().getTime(),
  },
  Payment: {
    deposit: {
      Cards: {
        Bog: "/api/?app=user/payment/sb2&type=getClientInfo",
        Tbc: "/api/?app=user/payment/tbcvisa_in_savecard&type=getClientInfo&action=in",
      },
      Bog: "/api/?app=user/payment/sb2&type=in&",
      Tbc: "/api/?app=user/payment/tbcvisa_in_savecard&type=in",
      CheckFirst: "/api/?app=aqcia/api&act=first",
      ClearFirst: "/api/?app=aqcia/api&act=first_completed",
    },
    withdraw: {
      Cards: {
        Bog: "/api/?app=user/payment/sb2&type=getClientInfo",
        Tbc: "/api/?app=user/payment/tbcvisa&type=getClientInfo",
      },
      Bog: "/api/?app=user/payment/sb2&type=out",
      Tbc: "/api/?app=user/payment/tbcvisa&type=withdraw",
      Nbc: {
        check: "/api/?app=user/payment/nbsnew&type=check",
        pay: "/api/?app=user/payment/nbsnew2&type=withdraw",
      },
      Emoney: "/api/?app=user/payment/emoney_pay_out",
      AllPayWay: "/api/?app=user/payment/allpayway",
    },
    remove: "/api/?app=user/payment/remove_card&id={id}&type={type}",
  },
  Rules: {
    GetMenus: "/reglament/?action=getMenus",
    GetData: "/reglament/?action=getData",
  },
  Branches: {
    List: "/api/?app=filials/get&lang={lang}",
  },
  Jackpots: {
    LiveCasino: "https://sportcache.lider-bet.com/jackpots/data.json",
    IgrosoftHeader:
      "https://ponger.lider-bet.com/index.php?app=jackpot/igrosoftFourJackpots",
    IgrosoftBody:
      "https://livedata.lider-bet.com/igrosoft/igrosoftJackpotInfo.json?_=1661351742478",
    LeaderPoker: "https://sportcache.lider-bet.com/jackpots/data.json",
  },
  Captcha: "/api/?app=helper/captcha&",
};

let importOrigin = "";
try {
  importOrigin = new URL(document.currentScript.src).origin;
} catch (e) {
  //invalid url, no prefix
}
export const URL_PREFIX = importOrigin;

const addPrefix = (obj) => {
  Object.keys(obj).map((k) => {
    typeof obj[k] === "object"
      ? addPrefix(obj[k])
      : (obj[k] =
          obj[k].indexOf("/") === 0 ? URL_PREFIX.concat(obj[k]) : obj[k]);
  });
};

addPrefix(Config);

export default Config;
